/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import PropertySearchForm from '../../blocks/property-search-form/property-search-form';
import './styles/_index.scss';

const PropertySearchBar = (props) => {
    return (
        <div className="property-search-bar" data-aos="fade-up">
            <div className="shell">
                <div className="property-search-bar__inner">
                    <PropertySearchForm 
                        propertyType={props.type}
                        department={props.department} 
                        propertyMap={props.propertyMap}
                        sort_by={props.sort_by}
                    />
                </div>
            </div>
        </div>
    )
}

export default PropertySearchBar;
